export type CsvValue = boolean | number | string | null | undefined;

function cell(value: CsvValue) {
  const raw = value === null || value === undefined ? "" : String(value);
  const numericString = typeof value === "string" && /^[+-]?\d+(?:\.\d+)?$/.test(raw);
  const unsigned = raw.replace(/^[+-]/, "");
  const unsafeNumber =
    numericString &&
    (/^0\d/.test(unsigned) || raw.replace(/\D/g, "").replace(/^0+/, "").length > 15);
  const text =
    unsafeNumber || /^[=@\t\r\n\uFF1D\uFF0B\uFF0D\uFF20]|^[+-](?!\d+(?:\.\d+)?$)/.test(raw)
      ? `'${raw}`
      : raw;
  return /[",\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

export function asCsv(headers: string[], rows: CsvValue[][]) {
  return [headers, ...rows].map((row) => row.map(cell).join(",")).join("\r\n");
}

export function downloadCsv(filename: string, headers: string[], rows: CsvValue[][]) {
  const blob = new Blob([`\uFEFF${asCsv(headers, rows)}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
